export default __webpack_public_path__ + "static/media/16088600-C6AD-45A2-8C5F-CB56DBE6F2C0_1_105_c.99fd5009.jpeg";